import Joi from "joi";

export const addressSchema = {
    address: Joi.object({
        street: Joi.string().required().label("Staße"),
        streetnumber: Joi.string().required().label("Hausnummer"),
        city: Joi.string().required().label("Stadt"),
        postalcode: Joi.string().required().label("Postleitzahl"),
        country: Joi.string().allow("", null).label("Land"),
    }).unknown(),
};

export const addressSchemaBuilder = (modifier = (f) => f) => ({
    address: Joi.object({
        street: modifier(Joi.string().label("Staße")),
        streetnumber: modifier(Joi.string().label("Hausnummer")),
        city: modifier(Joi.string().label("Stadt")),
        postalcode: modifier(Joi.string().label("Postleitzahl")),
        country: modifier(Joi.string().label("Land")),
    }).unknown(),
});
